import HttpClient from "../httpClient";
import { StationItem, StationFilter, StationFullData } from "../../models/types/station";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";
class StationService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<StationFilter>): Promise<DefaultResponseContent<StationItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StationItem[]>>("/admin/Station/GetAll", requestData);
        return response;
    }

    async getAllData(requestData: DefaultFilterRequest<StationFilter>): Promise<DefaultResponseContent<StationItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StationItem[]>>("/admin/Station/GetAllFullData", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Station/GetLookup");
        return response;
    }
    async getStationById(id: string): Promise<DefaultResponse<StationItem>> {
        const response = await this.service.get<DefaultResponse<StationItem>>(`/admin/Station/GetDetail/${id}`);
        return response;
    }
    
    async getStationfullData(id: string): Promise<DefaultResponse<StationFullData>> {
        const response = await this.service.get<DefaultResponse<StationFullData>>(`/admin/Station/GetDetailFullData/${id}`);
        return response;
    }

    async createStation(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Station/Create`, requestData);
        return response;
    }

    async updateStation(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Station/Update`, requestData);
        return response;
    }

    async deleteStation(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/Station/Delete/${id}`);
        return response;
    }

}

const stationSvc = new StationService();
export default stationSvc;
